import * as React from "react"
import { BasicTableSeeker } from "@ui-seeker/core"

import { BORDER_COLOR, BORDER_STYLE } from "@constants"
import { useSkuGroupModal } from "@hooks"
import { nameColumn, actionsColumn } from "./columns"


export default function GroupsTable({ data, ...props }) {

    const { skuGroupData } = useSkuGroupModal()
    
    return <BasicTableSeeker
        data={skuGroupData.value}
        headers={[[
            { 
                label: 'SKU Groups', 
                sx: { borderLeft: BORDER_STYLE, borderColor: BORDER_COLOR, fontWeight: 'bold', backgroundColor: "primary.lighter" } 
            },
            { 
                label: 'Actions',
                sx: { width: 150, borderLeft: BORDER_STYLE, borderColor: BORDER_COLOR, fontWeight: 'bold', backgroundColor: "primary.lighter" } 
            }
        ]]}
        columns={[
            nameColumn(),
            actionsColumn()
        ]}
        cardProps={{ sx: { boxShadow: 0 } }}
        sx={{ overflowX: 'hidden', width: 500 }}
        {...props}
    />
}